import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { RequestGroup } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";
import type { ICD10Code } from "../types";

interface CreateOrderParams {
  labNetwork?: (typeof RequestGroup.LAB_NETWORKS)[keyof typeof RequestGroup.LAB_NETWORKS];
  note?: string;
  icd10Codes?: ICD10Code[];
}

interface CreateOrderResponse {
  requestGroup: RequestGroup;
}

export const useCreateOrder = ({
  patientId,
  encounterId,
}: {
  patientId: string;
  encounterId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateOrderResponse, CreateOrderParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Labs.CREATE_ORDER({
        patientId,
        encounterId,
      }),
      mutationFn: (params = {}) => {
        return axiosInstance.post("/labs/order/create-order", {
          ...params,
          encounterId,
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT_V2({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
